import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Document from '@tiptap/extension-document';
import HighLight from '@tiptap/extension-highlight';
import History from '@tiptap/extension-history';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Strike from '@tiptap/extension-strike';
import Text from '@tiptap/extension-text';
import Underline from '@tiptap/extension-underline';
import Mention from '@tiptap/extension-mention';
import { TextStyle } from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import MentionSuggestions from '@/app/util/editor/mention_suggestions.js';

const CustomColor = Color.extend({
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-color') || element.style.color.replace(/['"]+/g, ''),
            renderHTML: (attributes) => {
              if (!attributes.color) return {};
              return {
                style: `color: ${attributes.color}`,
                'data-color': attributes.color,
              };
            },
          },
        },
      },
    ];
  },
});

const mapMentionItems = (employees, query) =>
  employees
    .map((employee) => ({
      label: employee.attributes.name,
      id: employee.id,
    }))
    .filter((item) => item.label.toLowerCase().includes(query.toLowerCase()))
    .sort((a, b) => a.label.localeCompare(b.label));

export const EDITOR_CONTENT_HTML_EMPTY = '<p></p>';
export const EDITOR_CONTENT_HTML_EMPTY_WITH_COLLAPSED_SPACES = '<p> </p>';
export const EDITOR_CONTENT_HTML_EMPTY_PUBLIC_API = '{"type":"doc","content":[{"type":"paragraph"}]}';

export const isEmptyHTML = (value) =>
  value === EDITOR_CONTENT_HTML_EMPTY ||
  value === EDITOR_CONTENT_HTML_EMPTY_WITH_COLLAPSED_SPACES ||
  value === EDITOR_CONTENT_HTML_EMPTY_PUBLIC_API;

export const EDITOR_TYPES = Object.freeze({
  REPLY: 'reply_editor',
  NOTE: 'note_editor',
});

export function createEditorExtensions({ placeholder, with_mentions, fetch_mentionable_employees }) {
  const extensions = [
    Document,
    Paragraph,
    Text,
    Bold,
    Italic,
    Strike,
    Underline,
    TextStyle,
    CustomColor,
    HighLight.configure({ multicolor: true }),
    History,
    BulletList,
    ListItem,
    OrderedList,
    Link.configure({ defaultProtocol: 'https' }),
    Placeholder.configure({
      emptyNodeClass: 'is-empty',
      placeholder,
      showOnlyWhenEditable: false,
    }),
  ];

  if (with_mentions) {
    extensions.push(
      Mention.configure({
        suggestion: {
          ...MentionSuggestions,
          items: async ({ query }) => {
            const employees = (await fetch_mentionable_employees()) || [];
            return mapMentionItems(employees, query);
          },
        },
      }),
    );
  }

  return extensions;
}
